module.exports = __webpack_public_path__ + "img/FCS.56d7ba89.png";